import React, { useState } from 'react';

function useFormState(config) {
    const { initialFormState, handleFormSubmission } = config;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState(initialFormState);

    const resetForm = () => {
        setFormData(initialFormState);
    };

    const bindUpdateFormData = (e) => {
        updateFormData(e.target.name, e.target.value);
    };

    const bindUpdateGoogleFormData = (e,v) => {
        updateFormData(e, v);
    };

    const bindUpdateFormDataNumber = (e) => {
        updateFormData(e.target.name, Number(e.target.value));
    };

    const updateFormData = (key, value) => {
        setFormData(prevState => {
            console.log('Updating Form Data:', key, value, {
                ...prevState,
                [key]: value,
            });

            return {
                ...prevState,
                [key]: value,
            };
        });
    };
    const updateFormDataBulk = (newFormData) => {
        setFormData(prevState => {
            return {
                ...prevState,
                ...newFormData,
            };
        });
    };

    const submitForm = (data, callback = {}) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        setIsSubmitting(true);
        handleFormSubmission(data, {
            success: (response) => {
                console.log(response);
                resetForm();

                // Callbacks
                if (successCallback) successCallback(response);
            },
            always: (response) => {
                setIsSubmitting(false);

                // Callbacks
                if (alwaysCallback) alwaysCallback(response);
            },
            error: (response) => {
                // Callbacks
                if (errorCallback) errorCallback(response);
            },
        });
    };

    return {
        formData,
        bindUpdateFormData,
        bindUpdateFormDataNumber,
        updateFormData,
        updateFormDataBulk,
        bindUpdateGoogleFormData,
        isSubmitting,
        setIsSubmitting,
        submitForm,
        resetForm,
    };
}

export default useFormState;
